module.exports = "<p-tree expanded=\"true\" [value]=\"_files\"></p-tree>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/userdata-generation/components/folder-treeview/folder-treeview.component.html
// module id = ../../../../../src/app/modules/models/userdata-generation/components/folder-treeview/folder-treeview.component.html
// module chunks = main